
import React, { Fragment } from 'react';
import { GetData, PostData, PutData } from '../../core/controls/helpers/requests';
import { requestApi } from '../../core/controls/helpers/rest';
import BreadCrumb from '../../core/modules/breadcrumbs';
import CFormDropDown from '../../core/modules/form/cformdropdown';
import { getToken } from '../../core/modules/header';
import { getEnvVariable } from '../../modules/environmentalList';
import KendoChart from '../chart/kendochart';
import ToggleChart from './toggleview';
import { Button } from '@material-ui/core';
const _ = require('lodash');

const siteTransformProps = {
  "value": "Id",
  "name": "Name",
  "key": "Id"
}

const permittypeTransformProps = {
  "value": "Id",
  "name": "Name",
  "key": "Id"
}

const permitsubtypeTransformProps = {
  "value": "Value",
  "name": "Name",
  "key": "Value"
}

const monthsTransformProps = {
  "value": "Id",
  "name": "Name",
  "key": "Id"
}

const yearTransformProps = {
  "value": "Id",
  "name": "Name",
  "key": "Id"
}


const monthsJson = [
  {
    "Id": "0",
    "Name": "All"
  },
  {
    "Id": "1",
    "Name": "January"
  },
  {
    "Id": "2",
    "Name": "Feburary"
  },
  {
    "Id": "3",
    "Name": "March"
  },
  {
    "Id": "4",
    "Name": "April"
  },
  {
    "Id": "5",
    "Name": "May"
  },
  {
    "Id": "6",
    "Name": "June"
  },
  {
    "Id": "7",
    "Name": "July"
  },
  {
    "Id": "8",
    "Name": "August"
  },
  {
    "Id": "9",
    "Name": "September"
  },
  {
    "Id": "10",
    "Name": "October"
  },
  {
    "Id": "11",
    "Name": "November"
  },
  {
    "Id": "12",
    "Name": "December"
  }
]
class DashboardChart extends React.Component {

  constructor(props) {
    super(props);
    this.token = getToken()
    this.state = {
      chartApplicationData: [],
      chartPermitData: [],
      site: 0,
      sitesJson: [],
      permitType: 0,
      monthName: '0',
      permitTypeJson: [],
      monthsJson: monthsJson,
      permitTypesConfig: [],
      year: new Date().getFullYear(),
      permitValue: '0',
      SubModuleKeyVAL: 0,
      SitePermitTypeVAL: 0,
      permitsubtypes: [],
      domainssubtypesresult: []
    }
  }

  componentDidMount() {
    this.loadInitialChart();

  }

  loadInitialApplicationChart = (body) => {
    const url = getEnvVariable('Report') + `/api/ReportQuery/QueryLoad`
    const queryParam = `kendoGrid=N&reportkey=DASHBOARD_SUMMARY_APPLICATIONS`;
    //this.setState({ chartApplicationData : [0,0,0,0,0,0,0,0,0,0,0,10] })
    this.fetchData('POST', url, queryParam, body)
      .then(data => {
        // let result = this.formatPieChartData(data);
        // data && data.length > 0 && data.map(res => {
        //   result.push(res.SatusCount)
        // })
        this.setState({
          chartApplicationData: data,

        })
      })
  }

  chartLegendName = (name) => {
    name = name.toLowerCase().replaceAll("_", " ")
    return name.charAt(0).toUpperCase() + name.slice(1);
  }

  formatPieChartData = (data) => {
    let result = [];
    if (data["StatusSettings"]) {
      let chartlabels = data["StatusSettings"]
      let arrchartlabels = chartlabels.split(',')

      if (arrchartlabels.length > 0) {
        arrchartlabels.forEach(element => {
          result.push({
            "share": data[element],
            "kind": this.chartLegendName(element)
          })
        });
      }
    }
    return result;
  }


  monthApplicationChart = (month, monthName) => {
    const body = {
      "SITEVAL": this.state.site,
      "PERMITVAL": this.state.permitType,
      "MONTHVAL": parseInt(month),
      "YEARVAL": this.state.year || new Date().getFullYear()
    }
    const url = getEnvVariable('Report') + `/api/ReportQuery/QueryLoad`
    const queryParam = `kendoGrid=N&reportkey=DASHBOARD_SUMMARY_APPLICATIONS`;
    this.fetchData('POST', url, queryParam, body)
      .then(data => {
        if (Array.isArray(data)) {
          let item = []

          if (data[0]["StatusSettings"]) {
            let chartlabels = data[0]["StatusSettings"]
            let arrchartlabels = chartlabels.split(',')

            if (arrchartlabels.length > 0) {
              arrchartlabels.forEach(element => {
                item.push({
                  "share": data[0][element],
                  "kind": this.chartLegendName(element)
                })
              });
            }
          } else {
            item = [
              {
                "share": data[0]["ADDITIONAL_INFORMATION_REQUIRED"],
                "kind": "Additional Information Required"
              },
              {
                "share": data[0]["APPROVED"],
                "kind": "Approved"
              },
              {
                "share": data[0]["AUTHORIZED"],
                "kind": "Authorized"
              },
              {
                "share": data[0]["COMPLETED"],
                "kind": "Completed"
              },
              {
                "share": data[0]["DENIED"],
                "kind": "Denied"
              },
              {
                "share": data[0]["EXPIRED"],
                "kind": "Expired"
              },
              {
                "share": data[0]["ONHOLD"],
                "kind": "Hold"
              },
              {
                "share": data[0]["ISSUED"],
                "kind": "Issued"
              },
              {
                "share": data[0]["RECEIVED"],
                "kind": "Received"
              },
              {
                "share": data[0]["REVIEW"],
                "kind": "Review"
              },
              {
                "share": data[0]["WARRANTY"],
                "kind": "Warranty"
              },
              {
                "share": data[0]["NOT_SUBMITTED"],
                "kind": "Not Submitted"
              },
              {
                "share": data[0]["SUBMITTED"],
                "kind": "Submitted"
              }
            ]
          }


          this.setState({
            chartMonthApplicationData: item,
            monthdisplay: true,
            monthName: monthName
          })
        }
        else {
          let item = [{
            share: "0",
            "kind": "No Data"
          }]
          this.setState({
            chartMonthApplicationData: item,
            monthdisplay: true,
            monthName: monthName
          })
        }
      })
  }



  loadInitialChart = () => {
    const sitedata = this.fetchData('GET', getEnvVariable('Admin') + `/api/sites/${getEnvVariable('ModuleKey')}/all/active`, null, null)
    const permittypedata = this.fetchData('GET', getEnvVariable('AdminConfig') + `/api/SitePermitTypesConfig/All`, null, null)
    const configType = getEnvVariable('ConfigType');
    const domainssubtypes = this.fetchData('GET', getEnvVariable('Application') + `/api/Domains/values?domainkey=PERMIT_TYPE`, null, null)
    Promise.all([sitedata, permittypedata, domainssubtypes]).then(data => {
      const sites = data[0]
      const permittypesconfig = data[1];
      const siteConfigPermitTypes = Array.isArray(permittypesconfig) ? permittypesconfig.filter(a => a.SiteId > 0) : []
      const districtConfigPermitTypes = Array.isArray(permittypesconfig) ? permittypesconfig.filter(a => a.DistrictId > 0).map(b => b.SitePermitTypes) : []
      const regionConfigPermitTypes = Array.isArray(permittypesconfig) ? permittypesconfig.filter(a => a.RegionId > 0).map(b => b.SitePermitTypes) : []
      const permittypes = configType === 'S' ? siteConfigPermitTypes.map(b => b.SitePermitTypes) : configType === 'D' ?
        districtConfigPermitTypes.map(b => b.SitePermitTypes) : configType === 'R' ?
          regionConfigPermitTypes.map(b => b.SitePermitTypes) : [];

      let initalpermit = [];
      let initalpermitConfig = permittypesconfig.filter(res => {
        if (sites[0].Id === res.SiteId)
          return res
      })
      if (Array.isArray(initalpermitConfig)) {
        initalpermit = initalpermitConfig.map(b => b.SitePermitTypes);
      }
      initalpermit.push({ Id: '0', Name: 'All', Status: 'A', PermitTypeId: '0' });


      this.setState({
        sitesJson: data[0],
        site: sites[0].Id,
        permitTypeJson: initalpermit.filter(e => e.Status === 'A'),//data[1],
        permitType: 0,//initalpermit[0].PermitTypeId,
        // monthdisplay: false,
        permitsAll: permittypes,
        permitTypesConfig: permittypesconfig,
        permitValue: '0', //initalpermit[0].PermitTypeId
        domainssubtypesresult: data[2],
        monthName: '0',
        year: new Date().getFullYear(),
      }, () => {
        const body = {
          "SITEVAL": sites[0].Id,
          "PERMITVAL": 0,//permittypes[0].PermitTypeId,
          "YEARVAL": 0,//this.state.year || new Date().getFullYear(),
          "MONTHVAL": 0,//,this.state.month || 0,
          "SubModuleKeyVAL": 0,
          SitePermitTypeVAL: 0
        }
        this.loadInitialApplicationChart(body);
        this.handleSubPermitType();
      })
    })
  }

  handleSubPermitType = (siteChange = false) => {
    if (this.state.domainssubtypesresult && this.state.domainssubtypesresult.length > 0) {
      // const read = [
      //   { get: { url: getEnvVariable('AdminConfig') + `/api/SitePermitTypeSubTypes/BySitePermitTypeId/${siteid}` } },

      // ]
      // Promise.all(read.map(each => requestApi(each))).then(res => {
      //   if (res) {
      //     let subtypeids = res[1] ? _.map(res[1], 'SubType') : []
      //     //this.setState({ subtypereults : subtypeids})
      //     if (Array.isArray(subtypeids)) {
      //       let savedsubtypereults = subtypeids;
      //       let domainres = this.state.domainssubtypesresult.map(x => savedsubtypereults.includes(Number(x.Value)) ? x : false);
      //       var filtered = domainres.filter(Boolean);
      let domainslist = this.state.domainssubtypesresult;
      if (!siteChange)
        domainslist.push({ Key: '0', Name: 'All', Value: '0' });
      let tempFiltered = this.handlefiltersub()
      this.setState({ permitsubtypes: tempFiltered && tempFiltered.length > 0 ? tempFiltered : domainslist })
      //    }
      // }
      //   })
      // }
    }
  }


  handlefiltersub = () => {
    let valuessite = this.state.domainssubtypesresult;
    // if (siteid === 3 || siteid === 4) {
    //   valuessite.filter(each => each.name)
    // }
    if (this.state.sitesJson && this.state.site) {
      let siteinitials = this.state.sitesJson.find(each => {
        return each.Id === this.state.site
      }).Initials
      if (siteinitials !== "NC") {
        valuessite = valuessite.filter(item => item.Value !== '4' && item.Value !== '1');
        return valuessite;
        //this.setState({ applicationutilitypermitsubtype: valuessite })
      }
    }
  }

  handleSiteDropdownChange = (event) => {
    const { permitsAll, permitTypesConfig } = this.state;
    let initalpermitConfig = permitTypesConfig.filter(res => {
      if (event.target.value === res.SiteId)
        return res
    });
    let initalpermit = initalpermitConfig.map(b => b.SitePermitTypes);
    // initalpermit.push({ Id: '0', Name: 'All', Status: 'A', PermitTypeId: '0' });
    this.setState({
      site: event.target.value,
      permitTypeJson: initalpermit,
      year: this.state.year,
      //monthdisplay: false,
      permitType: '0',
    }, () => {
      const body = {
        "SITEVAL": event.target.value,
        "PERMITVAL": '0',
        "MONTHVAL": this.state.monthName,
        "YEARVAL": this.state.year,
        "SubModuleKeyVAL": 0,
        SitePermitTypeVAL: 0
      }
      this.loadInitialApplicationChart(body);
      this.handleSubPermitType(true)
    })
  }

  handlePermitTypeDropdownChange = (event) => {
    let selectedpermit = this.state.permitTypeJson.filter(e => {
      if (event.target.value === e.Id)
        return e
    })
    this.setState({
      permitValue: event.target.value, permitType: selectedpermit[0].PermitTypeId
      // monthdisplay: false,
    }, () => {
      const body = {
        "SITEVAL": this.state.site,
        "PERMITVAL": selectedpermit[0].PermitTypeId,
        "YEARVAL": this.state.year || new Date().getFullYear(),
        "MONTHVAL": this.state.month,
        "SubModuleKeyVAL": this.state.SubModuleKeyVAL,
        SitePermitTypeVAL: 0
      }
      this.loadInitialApplicationChart(body)
    })

    //  this.loadInitialPermitChart(body)
  }

  handleSubPermitTypeDropdownChange = (event) => {
    this.setState({
      SitePermitTypeVAL: event.target.value
    }, () => {
      const body = {
        "SITEVAL": this.state.site,
        "PERMITVAL": this.state.permitValue || 0,
        "YEARVAL": this.state.year || new Date().getFullYear(),
        "MONTHVAL": this.state.monthName,
        "SubModuleKeyVAL": this.state.SubModuleKeyVAL,
        SitePermitTypeVAL: event.target.value
      }
      this.loadInitialApplicationChart(body)
    })

    //  this.loadInitialPermitChart(body)
  }


  handleMonthDropdownChange = (event) => {
    this.setState({
      monthName: event.target.value
    }, () => {
      const body = {
        "SITEVAL": this.state.site,
        "PERMITVAL": this.state.permitType,
        "MONTHVAL": parseInt(event.target.value),
        "YEARVAL": this.state.year || new Date().getFullYear(),
        "SubModuleKeyVAL": 0,
        SitePermitTypeVAL: 0
      }
      this.loadInitialApplicationChart(body)
    })
  }

  handleYearDropdownChange = (event) => {
    this.setState({
      year: event.target.value,
      monthName: '0'
    }, () => {
      const body = {
        "SITEVAL": this.state.site,
        "PERMITVAL": this.state.permitType,
        "YEARVAL": event.target.value || new Date().getFullYear(),
        "MONTHVAL": this.state.monthName,
        "SubModuleKeyVAL": 0,
        SitePermitTypeVAL: 0
      }

      this.loadInitialApplicationChart(body)
    })

    //  this.loadInitialPermitChart(body)
  }

  fetchData(requestType, url, queryParam, body) {
    const queryStr = queryParam != null ? `${url}?${queryParam}` : `${url}`
    if (requestType == "GET") {
      return GetData(queryStr);
    }
    else if (requestType == "POST") {
      return PostData(queryStr, body, true);
    }
    else if (requestType == "PUT")
      return PutData(queryStr, body, true);
  }

  getYears = () => {
    let currentyear = new Date().getFullYear();
    let yearlist = [];
    while (yearlist.length < 6) {
      yearlist.push({ Id: currentyear + 1, Name: (currentyear + 1).toString() });
      currentyear--;
    }
    // this.setState({ year: currentyear })
    return yearlist;
  }

  handlemonthval = (props) => {
    console.log(props);
    monthsJson.map(res => {
      if (res.Name === props) {
        this.monthApplicationChart(res.Id, res.Name);      //  this.loadInitialPermitChart(res.Id)

      }
    })
  }


  render() {
    let yearlist = this.getYears();
    const { chartApplicationData, permitTypeJson } = this.state
    const { options } = this.props;
    const { headerProps } = options
    return (
      <Fragment>
        <div className="col pt-1" style={{ backgroundColor: '#ffffff' }}>
          <BreadCrumb breadcrumbs={headerProps.breadcrumbs} /></div>
        <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#ffffff', padding: '10px' }}>
          <div className="col-3">
            <CFormDropDown value={this.state.site || 0} dropdownvalues={this.state.sitesJson} label="County" transformProps={siteTransformProps} handleFieldChange={this.handleSiteDropdownChange} />
          </div>
          <div className="col-1">
            <CFormDropDown value={this.state.year || new Date().getFullYear()} dropdownvalues={yearlist || []} label="Year" transformProps={yearTransformProps} handleFieldChange={this.handleYearDropdownChange} />
          </div>
          <div className="col-2">
            <CFormDropDown value={this.state.monthName || '0'} dropdownvalues={monthsJson || []} label="Month" transformProps={monthsTransformProps} handleFieldChange={this.handleMonthDropdownChange} />
          </div>
          <div className='col-4' />
          <div className='col-2 float-end'>
            <ToggleChart handleToggleView={(type) => this.setState({ type: type })} type={this.state.type} />
          </div>
        </div>
        {<div className="chartApplicationData mt-1 row" style={{ height: '90%', overflow: 'auto', backgroundColor: '#ffffff' }}>
          {chartApplicationData && chartApplicationData.length > 0 ?        
            chartApplicationData.map((item, index) => {
              let hasSubType = (permitTypeJson.find(each => each.SubModuleKey === item.SubModuleKey && item.SubModuleKey !== 'STATEPROJECTS'
              ) || {}).HasSubType || 'N'
              return <div className='col-6'>
                <KendoChart data={this.formatPieChartData(item)} type={this.state.type || null} item={item}
                  permitypevalue={this.state.SitePermitTypeVAL || '0'}
                  permitdropdownvalues={this.state.permitsubtypes?.length > 0 ? this.state.permitsubtypes : []}
                  handleFieldChange={this.handleSubPermitTypeDropdownChange} hasSubType={hasSubType}
                  title={(permitTypeJson.find(each => each.SubModuleKey === item.SubModuleKey) || {}).Name}
                  permittransformProps={permitsubtypeTransformProps}
                />
              </div>
            })
            : <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              height: '50vh'
            }}>
              <p style={{ textAlign: 'center' }}>
                Data Unavailable: Please check your filters or try again later.
              </p>
              <Button variant='text' color='secondary' onClick={this.loadInitialChart}>
                Revert to Initial Settings
              </Button>
            </div>}
        </div>}
      </Fragment>

    )
  }
}
//monthdisplay ? "col-sm-6" :
export default DashboardChart
